export const checkFileType = (file, allowedFileTypes) => {
    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
    const isValid = !!allowedFileTypes.find((allowedType) => {
        if (allowedType.endsWith("*")) {
            const allowedTypes = allowedType.substring(0, allowedType.length - 1);
            return file.type.startsWith(allowedTypes);
        }
        else {
            const fileType = file.name.split(".").pop();
            /**
             * The usage of file.type is not recommended as it is not reliable.
             * @see https://developer.mozilla.org/en-US/docs/Web/API/Blob/type
             */
            return allowedType === file.type || allowedType.split(".").pop() === fileType;
        }
    });
    return isValid;
};
//# sourceMappingURL=checkFileType.js.map
